<template>
	<LayoutList>
		<template slot="header">
			<h1>MADDs</h1>
			<a :href="downloadURL" class="btn btn-download">Download All</a>
			<router-link to="/madds/create" class="btn btn--primary" v-if="can('createMADDs')">
                Create
            </router-link>
		</template>

		<template slot="filters">
			<FormControlSector
                name="sectors"
                v-model="sectors"
                :multiple="true"
                :include-ancestors="false"
            />
			<FormControlDealType
                name="deal_type"
                v-model="filters.deal_type"
            />
			<FormControlMember
                name="member"
                v-model="filters.member"
                placeholder="Select..."
                label="Member company"
            />
			<FormControlDatepicker
                name="fromDate"
                v-model="filters.fromDate"
                label="From date"
            />
			<FormControlDatepicker
                name="toDate"
                v-model="filters.toDate"
                label="To date"
            />
		</template>

		<div class="form__group search" slot="search">
			<label for="local-search" class="form__label">Search MADDs</label>
			<input
                id="local-search"
                class="form__control search"
                type="search"
                placeholder="Filter by title"
                v-model="filters.query"
            />
		</div>

		<vue-tabs ref="tabs" @tab-change="onTabChange">
			<v-tab id="all" title="All MADDs">
				<ListMADDs
                    ref="all"
                    :load-on-start="false"
                    :filters="filteredFilters"
                />
			</v-tab>

			<v-tab id="mine" title="My MADDs">
				<ListMADDs
                    ref="mine"
                    :load-on-start="false"
                    :filters="filteredFilters"
                    :mine-only="true"
                />
			</v-tab>
			<!-- TODO: Show only to admins -->
			<v-tab id="pending" title="Pending MADDs" v-if="can('impersonateUsers')">
				<ListMADDs
                    ref="pending"
                    :load-on-start="false"
                    :filters="filteredFilters"
                    :pending-only="true"
                />
			</v-tab>
		</vue-tabs>
	</LayoutList>
</template>

<script>
	import { mapGetters } from 'vuex';
	import LayoutList from '../Layout/LayoutList';
	import ListMADDs from '../List/ListMADDs';
	import FormControlDealType from '../Form/Control/FormControlDealType';
	import FormControlSector from '../Form/Control/FormControlSector';
	import FormControlMember from '../Form/Control/FormControlMember';
	import FormControlDatepicker from '../Form/Control/FormControlDatepicker';
	import TabbedPage from '../TabbedPage';
    import FiltersFromUrl from '../FiltersFromUrl';
    import qs from 'qs';

	export default {
		name: 'MADDList',
		mixins: [TabbedPage, FiltersFromUrl],
		components: {
			FormControlMember,
			FormControlSector,
			FormControlDealType,
			FormControlDatepicker,
			ListMADDs,
			LayoutList,
		},
		data() {
			return {
				filters: {
					sectors: [],
					deal_type: null,
					member: null,
					query: null,
					fromDate: null,
					toDate: null
				},
				defaultTab: 'all',
				tabRoute: 'madds',
			}
		},
		computed: {
			...mapGetters([
				'can',
				'madds'
			]),
			downloadURL() {
				return '/madds/download?' + qs.stringify(this.filters);

			},
            filteredFilters() {
                return {
                    sectors: this.sectors,
                    deal_type: this.filters.deal_type,
                    member: this.filters.member,
                    query: this.filters.query,
                    fromDate: this.filters.fromDate,
                    toDate: this.filters.toDate
                }
            },
            sectors: {
                get() {
                    return this.filters.sectors.filter(function (el) {
                        return el !== 0;
                    });
                },
                set(value) {
                    this.filters.sectors = value;
                }
            }
		},
		watch: {
			filters: {
				deep: true,
				handler() {
					this.$store.commit('modifyMadds', {
						query: this.filters.query,
						sectors: this.sectors,
						deal_type: this.filters.deal_type,
						member_company: this.filters.member,
						from_date: this.filters.fromDate,
						to_date: this.filters.toDate
					});

                    console.log("[PageSearch.vue] - filters: ", this.filters);

                    // on filter change reset the page to 1
                    this.$refs.all.resetPagination();
                    this.$refs.mine.resetPagination();
                    this.$refs.pending.resetPagination();
				}
			},
            $route: {
                deep: true,
                handler() {
                    // this.load();
                    console.log("[PageSearch.vue] - query changed: ", this.filters);
                }
            }
		},
        mounted() {
            console.log("[PageSearch.vue] - query: ", this.filters);
        },
		methods: {
			load() {
                // todo: Reset 'modifyMadds' on side menu clicks

                // if(this.$route.query) {
                //     // on page load reset the filters
                //     const sector = this.$route.query.sectors;
                //     console.log("Sector: " + sector)
                //     // this.filters.sectors = this.$route.query.sectors;
                // } else {
                //     console.log("No Sectors are set!! ", this.$route.query);
                // }

				// this.filters.query = this.madds.query;
				// this.filters.sectors = this.madds.sectors;
				// this.filters.deal_type = this.madds.deal_type;
				// this.filters.member = this.madds.member_company;
				// this.filters.fromDate = this.madds.from_date;
				// this.filters.toDate = this.madds.to_date;
			},
		},
		created() {
			this.load();
		}
	}
</script>
